import styled from 'styled-components';
import ControllBar from './ControllBar';
import TimelineBar from './TimelineBar';
import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { WebSDKcctv } from '../../../../utils/webSDKcctvClass';

const Root = styled.div``;

interface Props {
  visiblePanel: boolean;
  setVisiblePanel: Dispatch<SetStateAction<boolean>>;
  cctvOBJ: WebSDKcctv | undefined; // cctv 객체
  cctvDivisions: number; // cctv 분할
  onClickDivision: (number: 1 | 2 | 3 | 4) => void;
  selectedCameraInfo: SelectedCctvCameraInfo;
  setSelectedCameraInfo: Dispatch<SetStateAction<SelectedCctvCameraInfo>>;
  nvrList: IMainMenu[];
  setNvrList: Dispatch<SetStateAction<IMainMenu[]>>;
  recordData: Playback[];
  videoWindow: VideoWindow;
  onClickPlay: (param: { reverse?: boolean; currentTime?: number }) => void;
  onClickPause: () => void;
  cctvSettings: CctvSettings;
  onClickSpeed: (speed: 'fast' | 'slow') => void;
  windows: {
    windowIndex: number;
    clock: {
      currentTime: number; //
      setCurrentTime: Dispatch<SetStateAction<number>>;
      setIsPlaying: Dispatch<SetStateAction<boolean>>;
      setSpeed: Dispatch<SetStateAction<1 | 2 | 4>>;
      speed: 1 | 2 | 4;
      currentDate: string;
      setCurrentDate: Dispatch<SetStateAction<string>>;
      isReversed: boolean;
      setIsReversed: Dispatch<SetStateAction<boolean>>;
    };
  }[];
}

const BottomMenu = ({
  visiblePanel, //
  setVisiblePanel,
  cctvOBJ,
  cctvDivisions,
  onClickDivision,
  selectedCameraInfo,
  setSelectedCameraInfo,
  nvrList,
  setNvrList,
  recordData,
  videoWindow,
  onClickPlay,
  onClickPause,
  cctvSettings,
  onClickSpeed,
  windows,
}: Props) => {
  // undefined인 경우 null 리턴
  if (cctvOBJ === undefined) return null;

  return (
    <Root>
      <ControllBar //
        visiblePanel={visiblePanel}
        setVisiblePanel={setVisiblePanel}
        cctvOBJ={cctvOBJ}
        cctvDivisions={cctvDivisions}
        onClickDivision={onClickDivision}
        selectedCameraInfo={selectedCameraInfo}
        setSelectedCameraInfo={setSelectedCameraInfo}
        nvrList={nvrList}
        setNvrList={setNvrList}
        videoWindow={videoWindow}
        onClickPlay={onClickPlay}
        onClickPause={onClickPause}
        cctvSettings={cctvSettings}
        onClickSpeed={onClickSpeed}
        windows={windows}
      />
      <TimelineBar //
        visiblePanel={visiblePanel}
        cctvOBJ={cctvOBJ}
        recordData={recordData}
        selectedCameraInfo={selectedCameraInfo}
        onClickPause={onClickPause}
        videoWindow={videoWindow}
        onClickPlay={onClickPlay}
      />
    </Root>
  );
};

export default BottomMenu;
